interface IconProps {
  className?: string
}

/** Apple wordmark glyph. Color via `fill-*` (defaults to currentColor). */
export function AppleIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
      <path d="M17.05 12.18c0-2.06 1.69-3.05 1.77-3.1-0.97-1.42-2.49-1.61-3.03-1.64-1.29-0.13-2.51 0.76-3.16 0.76-0.66 0-1.66-0.74-2.74-0.72-1.41 0.02-2.71 0.82-3.43 2.08-1.46 2.54-0.37 6.29 1.05 8.36 0.7 1.02 1.53 2.16 2.61 2.12 1.05-0.04 1.45-0.68 2.72-0.68 1.27 0 1.62 0.68 2.73 0.66 1.13-0.02 1.84-1.02 2.53-2.05 0.8-1.18 1.13-2.32 1.15-2.38-0.03-0.01-2.21-0.85-2.23-3.36zM15.06 6.42c0.57-0.69 0.96-1.65 0.85-2.61-0.83 0.04-1.83 0.55-2.42 1.24-0.53 0.61-0.99 1.59-0.87 2.53 0.92 0.07 1.87-0.47 2.44-1.16z" />
    </svg>
  )
}

/** Google "G" mark in its brand colors. */
export function GoogleIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  )
}
